(function () {
  var AD_ID = 'human-urn-inline-ad';
  var HIDDEN_CLASS = 'human-urn-inline-ad--hidden';

  function getAdElement() {
    return document.getElementById(AD_ID);
  }

  function getArticleContentContainer() {
    return (
      document.querySelector('[data-article-content]') ||
      document.querySelector('.article-template__content') ||
      document.querySelector('.article-template__content.rte') ||
      document.querySelector('article.article-template .rte') ||
      document.querySelector('article .rte')
    );
  }

  function isIgnorableBlock(el) {
    if (!el || !el.tagName) return true;
    var tag = el.tagName.toLowerCase();
    return tag === 'script' || tag === 'style' || tag === 'template';
  }

  function containsMedia(el) {
    if (!el || !el.querySelector) return false;
    return !!el.querySelector('img, picture, figure, svg, video, iframe');
  }

  function isEligibleAnchor(el) {
    if (!el || !el.tagName) return false;
    if (isIgnorableBlock(el)) return false;

    var tag = el.tagName.toLowerCase();
    if (tag === 'h1' || tag === 'h2' || tag === 'h3' || tag === 'h4') return false;

    var allowed = ['p', 'ul', 'ol', 'blockquote', 'div'];
    if (allowed.indexOf(tag) === -1) return false;
    if (containsMedia(el)) return false;

    if (tag === 'p') {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (text.length === 0) return false;
    }

    return true;
  }

  function isAdjacentToMedia(el) {
    if (!el) return false;
    var prev = el.previousElementSibling;
    var next = el.nextElementSibling;
    return (prev && containsMedia(prev)) || (next && containsMedia(next));
  }

  function getBlocks(container) {
    if (!container) return [];
    var children = Array.prototype.slice.call(container.children || []);
    return children.filter(function (el) {
      return !isIgnorableBlock(el);
    });
  }

  function pickBestAnchor(blocks, strict) {
    if (!blocks || blocks.length === 0) return null;

    var candidates = [];
    var minIndex = Math.min(2, Math.max(0, blocks.length - 1));
    var maxIndex = Math.max(0, blocks.length - 3);

    for (var i = minIndex; i <= maxIndex; i++) {
      var el = blocks[i];
      if (!isEligibleAnchor(el)) continue;
      if (strict && isAdjacentToMedia(el)) continue;
      candidates.push(i);
    }

    if (candidates.length === 0) return null;

    var target = Math.floor(blocks.length * 0.4);
    candidates.sort(function (a, b) {
      return Math.abs(a - target) - Math.abs(b - target);
    });

    return blocks[candidates[0]];
  }

  function findAnchorBetweenH2Headings(container, strict) {
    if (!container || !container.querySelectorAll) return null;

    var headings = container.querySelectorAll('h2');
    if (!headings || headings.length < 2) return null;

    var startIndices = [];
    if (headings.length >= 3) startIndices.push(1);
    for (var i = 0; i < headings.length - 1; i++) {
      if (startIndices.indexOf(i) === -1) startIndices.push(i);
    }

    for (var idx = 0; idx < startIndices.length; idx++) {
      var startHeading = headings[startIndices[idx]];
      var endHeading = headings[startIndices[idx] + 1];
      if (!startHeading || !endHeading) continue;

      var node = startHeading.nextElementSibling;
      while (node && node !== endHeading) {
        if (isEligibleAnchor(node) && (!strict || !isAdjacentToMedia(node))) {
          return node;
        }
        node = node.nextElementSibling;
      }
    }

    return null;
  }

  function placeAdInArticle(ad, container) {
    var headingAnchor = findAnchorBetweenH2Headings(container, true);
    if (!headingAnchor) headingAnchor = findAnchorBetweenH2Headings(container, false);

    if (headingAnchor && headingAnchor.parentNode) {
      headingAnchor.parentNode.insertBefore(ad, headingAnchor.nextSibling);
      return true;
    }

    var blocks = getBlocks(container);
    var anchor = pickBestAnchor(blocks, true);
    if (!anchor) anchor = pickBestAnchor(blocks, false);

    if (!anchor) {
      container.appendChild(ad);
      return true;
    }

    if (!anchor.parentNode) return false;
    anchor.parentNode.insertBefore(ad, anchor.nextSibling);
    return true;
  }

  function prefersReducedMotion() {
    try {
      return (
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    } catch (e) {
      return false;
    }
  }

  function initRotation(ad) {
    var heroImages = ad.querySelectorAll('.human-urn-inline-ad__hero-img');
    var thumbs = ad.querySelectorAll('.human-urn-inline-ad__thumb');
    if (!heroImages || heroImages.length <= 1) return;

    var intervalAttr = ad.getAttribute('data-hua-rotate-interval');
    var interval = 4800;
    if (intervalAttr) {
      var parsed = parseInt(intervalAttr, 10);
      if (!isNaN(parsed) && parsed >= 1500) interval = parsed;
    }

    var index = Math.floor(Math.random() * heroImages.length);
    var timer = null;

    function setActive(i) {
      for (var k = 0; k < heroImages.length; k++) {
        heroImages[k].classList.toggle('is-active', k === i);
        if (thumbs && thumbs[k]) thumbs[k].classList.toggle('is-active', k === i);
      }
    }

    function next() {
      index = (index + 1) % heroImages.length;
      setActive(index);
    }

    function start() {
      if (timer) return;
      timer = window.setInterval(next, interval);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    setActive(index);

    // Allow users to click the image boxes (thumbnails) to preview each urn.
    // IMPORTANT: The whole card is a link to the collection, so we prevent navigation
    // only for thumbnail clicks.
    if (thumbs && thumbs.length) {
      Array.prototype.slice.call(thumbs).forEach(function (thumb, i) {
        if (!thumb) return;
        thumb.addEventListener('click', function (ev) {
          if (ev) {
            ev.preventDefault();
            ev.stopPropagation();
          }
          index = i;
          setActive(index);

          // Reset the timer so the user has a full interval to view their selection.
          stop();
          if (!prefersReducedMotion()) start();
        });
      });
    }

    // If the visitor prefers reduced motion, keep manual switching but disable auto-rotation.
    if (prefersReducedMotion()) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) start();
            else stop();
          });
        },
        { threshold: 0.25 }
      );

      io.observe(ad);
    } else {
      start();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });
  }

  function init() {
    var ad = getAdElement();
    if (!ad) return;
    if (ad.dataset.huaPlaced === '1') return;

    var container = getArticleContentContainer();
    if (!container) return;

    var placed = placeAdInArticle(ad, container);
    if (!placed) return;

    ad.dataset.huaPlaced = '1';
    ad.classList.remove(HIDDEN_CLASS);
    ad.removeAttribute('hidden');

    initRotation(ad);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
